
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexyUY0aEu02h9e_45AlelNcgUnj5CHWSFvsV1bssnOkuxzYMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/index.vue?macro=true";
import { default as indexYCSo9g_453o8EMUZ3zRH6Sn9QMMimtCvCQAjZuq8lFVPAMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/login/index.vue?macro=true";
import { default as indexbrHvXrm06srJm9CKcvQQocVtEm9TBpqUTKp7i6_mSooMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/aanbod/index.vue?macro=true";
import { default as indexj6lHhQujiiTXdpJWE6jZ0fQCpmgfBi86qvJMD2V1qNwMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/afspraak/index.vue?macro=true";
import { default as _91token_93outVsD_45dGpuYVuyOq_4514o9DOVnjkmAdfVvvSUZG8ZZEMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/onfido/[token].vue?macro=true";
import { default as _91hash_93tJu9nvSdbL_0q4bZLCFzBMPvca97kGGUVFApjkHgvlkMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/payment/[hash].vue?macro=true";
import { default as _91hash_93vZhfZsgujGos9w6OnBuoRNY4lcj5t9axP2dJmqtjIEQMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/passeren/[hash].vue?macro=true";
import { default as indexdpqYq9_sHSqBP26a9YYNZJtqU0DOj55WL_45FqQhlWk6cMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/hypotheken/index.vue?macro=true";
import { default as _91id_93jikpsQfBJXzpMAeP5q3gpgIWJeLPVrJRoD4SmmRDSBAMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/sso/[token]/[id].vue?macro=true";
import { default as _91slug_93o92bBXiLu99yRxAw7_45zRqE5Ev1FoL1z9ag57S4BgQ90Meta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/onboarding/[slug].vue?macro=true";
import { default as indexDhukDrSGiqEUQ_FMtxkc16T_45BmfTEQA8VRLGASzmOJMMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/sso/[token]/index.vue?macro=true";
import { default as index7mlvn0_45siPkxVASH0tLucT5dBQzDSW_45rszSQXPrgM6sMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/instellingen/index.vue?macro=true";
import { default as index21a_45SdIyD3LJKWyy5exxe1RREhFhHIeITtbNexQmQ2IMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-profiel/index.vue?macro=true";
import { default as errordxi4h9sYXRVFlzs5iyslxWpE4XoHPYPUPo0Pcty_2X0Meta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/ockto/[hash]/error.vue?macro=true";
import { default as indexSPHFVKIFI6tLhTf7UxunTHK3_457Z8KSX_45M1EIZB2y99wMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/ockto/[hash]/index.vue?macro=true";
import { default as indexAsjx0UlTnUFpC7rqDaNgm3Hor_AYGNnusy0chXqkRicMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/investeringen/index.vue?macro=true";
import { default as qrcodekIE01TnQpvWVDvihAVnJDoFyMHUpUHvESER8Xkq9UXcMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/ockto/[hash]/qrcode.vue?macro=true";
import { default as succesZ4PhU7O6KqsCI8_45GU_45OZBFXvcOqNHwI9qz9mHkwlnLoMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/ockto/[hash]/succes.vue?macro=true";
import { default as aanvraagf25F17qQUCeTz9K8uVjuTgBQpPG98QcS0l9vYkT6bnkMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/onboarding/aanvraag.vue?macro=true";
import { default as indexjw4LDgAunNB4QvrzdFsIgg_45DiAgoyAT0lKQviUTRfwwMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-aanvragen/index.vue?macro=true";
import { default as indexUJ1i8A2_DhxFvSNyg_45AJ3GSTeYHUV1kMF49vsciP58oMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mogelijk-fonds/index.vue?macro=true";
import { default as _91hash_93db9Xb_AEQtAiq0Z3u_pbg2UHx8lvo6gXVEDO6LGCIGAMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/rentevoorstel/[hash].vue?macro=true";
import { default as _91hash_93Bdq9xuaT1CvT0aJ4981IWh0_45nuzL5B1gfPXPFdoVP4QMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/verzekeringen/[hash].vue?macro=true";
import { default as indexJUP_6uczNIk9rKJ7dAvKHf5OAMWZmTPpsekjwJz5e8MMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/afspraak/[hash]/index.vue?macro=true";
import { default as indext59GW4Qe8_45woxJ_yhq9xvlz6XT7IFOe4UcjfpEKXBRYMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/feedback/[hash]/index.vue?macro=true";
import { default as index_FhMsjWPF6M3GuUzOokTn7d_iU2vwHa_45x_qRzSE2XW0Meta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/hypotheken/[id]/index.vue?macro=true";
import { default as index18fNN2F0BuHQEd7JGP7wBqptYhQ7zaI00Cx9ZPmY6BIMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/claims-en-opties/index.vue?macro=true";
import { default as reset_45wachtwoord8LtPJI_458PV_45elOyWtDFMBCJyYLGxhFTvQlzAoVKByjYMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/login/reset-wachtwoord.vue?macro=true";
import { default as indexj_45k6tpqTLafm5q_SBkDhYsOdXx1XnG6Kt9oiBQYKLg4Meta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-partnerplan/index.vue?macro=true";
import { default as indexJB0_45qO2rAEOlPZNC_45C3_ahXS43aaEs7dusQChP_450TcQMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-organisaties/index.vue?macro=true";
import { default as indexXmm0QByZNvifXj8Pc2D5P_45dyWYExi3Ob_45CaeTRFS1HYMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/investeringen/[id]/index.vue?macro=true";
import { default as indexE074JzJCetTJev1O6f27LSeJSxTM2pcxB19xbjPmtksMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/privacy-verklaring/index.vue?macro=true";
import { default as indexWYfxu99qBkK5VeQUc4Soe_plx84_Hh_s4GugiQy3V6kMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/hypotheek-overzicht/index.vue?macro=true";
import { default as wachtwoord_45vergetenzEbruNssi95AyjHaFJx4vQcfgLb_45CAQSeGPytcnJOz8Meta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/login/wachtwoord-vergeten.vue?macro=true";
import { default as indexj_8eL2yXxmIy76kP21PkazCrBEH6iK7TmpbSOiRE1EcMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mogelijk-fonds/[id]/index.vue?macro=true";
import { default as indexGS8_14mW5u1WyR1DBn18Z9IiMKM_45nprPG7snX_0J2psMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/financieel-overzicht/index.vue?macro=true";
import { default as _91hash_9327yGFPSRv7gNujqateeBaJkIe5EL3OQJfEdv5YHnbg4Meta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/einde-looptijd-lening/[hash].vue?macro=true";
import { default as _91fundKey_93cJnbvH_0Zqw3kjk4DcAxge79G0OrB_45YyvvWE6sGQnUgMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/sso/[exchangeToken]/[fundKey].vue?macro=true";
import { default as indexwaYVXzAotGiXNJfdWKqPuVTVlIXhUTJeWDCWypAlKfUMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-profiel/naw-gegevens/index.vue?macro=true";
import { default as _91token_93vwt6RoLAF7H8_Bmm8273nwkuuuQ2hWlIQbfZJ_45_4549GQMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/onboarding/[signing_id]/[token].vue?macro=true";
import { default as _91experience_93DO6xvH24qwnkFlTO8jn2h1WDwSW_PHjMoG1WtWD7bxMMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/onboarding/bedankt/[experience].vue?macro=true";
import { default as indexTJAcQv_45yIl78aioadt_45ZF7jd6cVS_8uf9_45IpbAehy4IMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/financieel-overzicht/rente/index.vue?macro=true";
import { default as indexh9sB5Fltbpq09UJwevLnQ_45BM56HWoM0EbpwN3jxqAVAMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-profiel/iban-overzicht/index.vue?macro=true";
import { default as indexfkxyox4y1i04LZ_gXSqY9V7ibgQuomNJ_czESwhGLhEMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-aanvragen/[offerNumber]/index.vue?macro=true";
import { default as index_D3iRcr4UfNnMPOBHQzqG3g9YxlokKNFYcpXO184rw8Meta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mogelijk-fonds/[id]/deelname/index.vue?macro=true";
import { default as indexpBSV39xzvNqT07Iz9zj2vgVcE213ZAtjGFlth0U_BxkMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mogelijk-fonds/[id]/overmaken/index.vue?macro=true";
import { default as indexJdnwt_45A1WJBljvrDiAVbIA6GY5tVBiLaCdcEC_45oYf3YMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/financieel-overzicht/financien/index.vue?macro=true";
import { default as indexFdxJgsxX_45SR0k2Saty77RTgNKIUsfiNVgjY2_45VwGCbMMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mogelijk-fonds/[id]/documenten/index.vue?macro=true";
import { default as index0m0WmIgFDRRUMFevcorlQPBGQ2nFppYptStwmrqkWlYMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/sso/[exchangeToken]/onboarding/index.vue?macro=true";
import { default as indexNo4IaYmb2HGsCApV5uBw99RbUSbcgKyjbbvvDBurUOUMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mogelijk-fonds/[id]/inschrijving/index.vue?macro=true";
import { default as indexmF5Vt8aF2e95FVqXd5UUydxvy957nP7Hmm90fr8ALb4Meta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mogelijk-fonds/[id]/ondertekenen/index.vue?macro=true";
import { default as indexpetWy7dU6uBpK0ohzcRTW_PRKqTsMSueNGPQsOj_mLYMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-partnerplan/[token]/[choice]/index.vue?macro=true";
import { default as aanvraag6k9o4vsm1l_msCKKySffzFC7vxb2hAzcH6kFpMCOpQMMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/sso/[exchangeToken]/onboarding/aanvraag.vue?macro=true";
import { default as _91choice_93sR1EH3ZhoKjumRNPadkmzJsNxG59VinHjZ1GfaSBNKMMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/aanbod-optie/[propertyId]/[hash]/[choice].vue?macro=true";
import { default as indexbknDebENroFtu9lT85JYhhB2Tof7En9uyvDNcUIbrpkMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-organisaties/bedrijfs-gegevens/index.vue?macro=true";
import { default as indexkz_45w5OoYcs4OXzSv0EXIWu5PLF7AvtQsMRZcnPQn3sQMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-profiel/digitaal-identificeren/index.vue?macro=true";
import { default as indexVx1xqskUBdFP8_45fcgVk7NbtRt_jnm8B54cPgzuu7_GAMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-aanvragen/[offerNumber]/herkomst/index.vue?macro=true";
import { default as indexcvOxTakMYWc4H187s48DCitvJReKKo9I1hqqPRLyP2EMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/fonds-optie/[property_id]/[hash]/[type]/index.vue?macro=true";
import { default as indexVsz4hCjlgg1ufumGtnT3KykC2kkeqR3pOyrPAVDfPngMeta } from "/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-organisaties/[companyId]/iban-overzicht/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexyUY0aEu02h9e_45AlelNcgUnj5CHWSFvsV1bssnOkuxzYMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexYCSo9g_453o8EMUZ3zRH6Sn9QMMimtCvCQAjZuq8lFVPAMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/login/index.vue")
  },
  {
    name: "aanbod",
    path: "/aanbod",
    meta: indexbrHvXrm06srJm9CKcvQQocVtEm9TBpqUTKp7i6_mSooMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/aanbod/index.vue")
  },
  {
    name: "Afspraak maken",
    path: "/afspraak",
    meta: { ...(indexj6lHhQujiiTXdpJWE6jZ0fQCpmgfBi86qvJMD2V1qNwMeta || {}), ...{"middleware":["auth","investor","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/afspraak/index.vue")
  },
  {
    name: "onfido-token",
    path: "/onfido/:token()",
    meta: _91token_93outVsD_45dGpuYVuyOq_4514o9DOVnjkmAdfVvvSUZG8ZZEMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/onfido/[token].vue")
  },
  {
    name: "payment-hash",
    path: "/payment/:hash()",
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/payment/[hash].vue")
  },
  {
    name: "passeren-hash",
    path: "/passeren/:hash()",
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/passeren/[hash].vue")
  },
  {
    name: "borrowerInvestments",
    path: "/hypotheken",
    meta: { ...(indexdpqYq9_sHSqBP26a9YYNZJtqU0DOj55WL_45FqQhlWk6cMeta || {}), ...{"middleware":["auth","avborrower","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/hypotheken/index.vue")
  },
  {
    name: "sso-token-id",
    path: "/sso/:token()/:id()",
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/sso/[token]/[id].vue")
  },
  {
    name: "onboarding-slug",
    path: "/onboarding/:slug()",
    meta: { ...(_91slug_93o92bBXiLu99yRxAw7_45zRqE5Ev1FoL1z9ag57S4BgQ90Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/onboarding/[slug].vue")
  },
  {
    name: "sso-token",
    path: "/sso/:token()",
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/sso/[token]/index.vue")
  },
  {
    name: "instellingen",
    path: "/instellingen",
    meta: { ...(index7mlvn0_45siPkxVASH0tLucT5dBQzDSW_45rszSQXPrgM6sMeta || {}), ...{"middleware":["auth","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/instellingen/index.vue")
  },
  {
    name: "mijn-profiel",
    path: "/mijn-profiel",
    meta: { ...(index21a_45SdIyD3LJKWyy5exxe1RREhFhHIeITtbNexQmQ2IMeta || {}), ...{"middleware":["auth","investor"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-profiel/index.vue")
  },
  {
    name: "ockto-error",
    path: "/ockto/:hash()/error",
    meta: errordxi4h9sYXRVFlzs5iyslxWpE4XoHPYPUPo0Pcty_2X0Meta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/ockto/[hash]/error.vue")
  },
  {
    name: "ockto",
    path: "/ockto/:hash()",
    meta: indexSPHFVKIFI6tLhTf7UxunTHK3_457Z8KSX_45M1EIZB2y99wMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/ockto/[hash]/index.vue")
  },
  {
    name: "/investeringen.page-title",
    path: "/investeringen",
    meta: { ...(indexAsjx0UlTnUFpC7rqDaNgm3Hor_AYGNnusy0chXqkRicMeta || {}), ...{"middleware":["auth","avinvestor","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/investeringen/index.vue")
  },
  {
    name: "ockto-qrcode",
    path: "/ockto/:hash()/qrcode",
    meta: { ...(qrcodekIE01TnQpvWVDvihAVnJDoFyMHUpUHvESER8Xkq9UXcMeta || {}), ...{"middleware":["qrcode"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/ockto/[hash]/qrcode.vue")
  },
  {
    name: "ockto-success",
    path: "/ockto/:hash()/succes",
    meta: succesZ4PhU7O6KqsCI8_45GU_45OZBFXvcOqNHwI9qz9mHkwlnLoMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/ockto/[hash]/succes.vue")
  },
  {
    name: "onboarding-aanvraag",
    path: "/onboarding/aanvraag",
    meta: { ...(aanvraagf25F17qQUCeTz9K8uVjuTgBQpPG98QcS0l9vYkT6bnkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/onboarding/aanvraag.vue")
  },
  {
    name: "mijn-aanvragen",
    path: "/mijn-aanvragen",
    meta: { ...(indexjw4LDgAunNB4QvrzdFsIgg_45DiAgoyAT0lKQviUTRfwwMeta || {}), ...{"middleware":["aanvragen"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-aanvragen/index.vue")
  },
  {
    name: "mogelijk-fonds",
    path: "/mogelijk-fonds",
    meta: { ...(indexUJ1i8A2_DhxFvSNyg_45AJ3GSTeYHUV1kMF49vsciP58oMeta || {}), ...{"middleware":["auth","fund"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mogelijk-fonds/index.vue")
  },
  {
    name: "rentevoorstel-hash",
    path: "/rentevoorstel/:hash()",
    meta: _91hash_93db9Xb_AEQtAiq0Z3u_pbg2UHx8lvo6gXVEDO6LGCIGAMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/rentevoorstel/[hash].vue")
  },
  {
    name: "verzekeringen-hash",
    path: "/verzekeringen/:hash()",
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/verzekeringen/[hash].vue")
  },
  {
    name: "Afspraak inplannen",
    path: "/afspraak/:hash()",
    meta: indexJUP_6uczNIk9rKJ7dAvKHf5OAMWZmTPpsekjwJz5e8MMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/afspraak/[hash]/index.vue")
  },
  {
    name: "/feedback.page-title",
    path: "/feedback/:hash()",
    meta: indext59GW4Qe8_45woxJ_yhq9xvlz6XT7IFOe4UcjfpEKXBRYMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/feedback/[hash]/index.vue")
  },
  {
    name: "borrowerInvestment",
    path: "/hypotheken/:id()",
    meta: { ...(index_FhMsjWPF6M3GuUzOokTn7d_iU2vwHa_45x_qRzSE2XW0Meta || {}), ...{"middleware":["auth","avborrower","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/hypotheken/[id]/index.vue")
  },
  {
    name: "claims-en-opties",
    path: "/claims-en-opties",
    meta: { ...(index18fNN2F0BuHQEd7JGP7wBqptYhQ7zaI00Cx9ZPmY6BIMeta || {}), ...{"middleware":["auth","investor","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/claims-en-opties/index.vue")
  },
  {
    name: "loginResetPassword",
    path: "/login/reset-wachtwoord",
    meta: reset_45wachtwoord8LtPJI_458PV_45elOyWtDFMBCJyYLGxhFTvQlzAoVKByjYMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/login/reset-wachtwoord.vue")
  },
  {
    name: "partnerplan",
    path: "/mijn-partnerplan",
    meta: { ...(indexj_45k6tpqTLafm5q_SBkDhYsOdXx1XnG6Kt9oiBQYKLg4Meta || {}), ...{"middleware":["auth","partnerplan"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-partnerplan/index.vue")
  },
  {
    name: "mijn-organisaties",
    path: "/mijn-organisaties",
    meta: { ...(indexJB0_45qO2rAEOlPZNC_45C3_ahXS43aaEs7dusQChP_450TcQMeta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-organisaties/index.vue")
  },
  {
    name: "investment",
    path: "/investeringen/:id()",
    meta: { ...(indexXmm0QByZNvifXj8Pc2D5P_45dyWYExi3Ob_45CaeTRFS1HYMeta || {}), ...{"middleware":["auth","avinvestor","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/investeringen/[id]/index.vue")
  },
  {
    name: "privacy-verklaring",
    path: "/privacy-verklaring",
    meta: indexE074JzJCetTJev1O6f27LSeJSxTM2pcxB19xbjPmtksMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/privacy-verklaring/index.vue")
  },
  {
    name: "hypotheek",
    path: "/hypotheek-overzicht",
    meta: { ...(indexWYfxu99qBkK5VeQUc4Soe_plx84_Hh_s4GugiQy3V6kMeta || {}), ...{"middleware":["auth","avborrower","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/hypotheek-overzicht/index.vue")
  },
  {
    name: "loginForgotPassword",
    path: "/login/wachtwoord-vergeten",
    meta: wachtwoord_45vergetenzEbruNssi95AyjHaFJx4vQcfgLb_45CAQSeGPytcnJOz8Meta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/login/wachtwoord-vergeten.vue")
  },
  {
    name: "mogelijk-fonds-id",
    path: "/mogelijk-fonds/:id()",
    meta: { ...(indexj_8eL2yXxmIy76kP21PkazCrBEH6iK7TmpbSOiRE1EcMeta || {}), ...{"middleware":["auth","currentfund","fund"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mogelijk-fonds/[id]/index.vue")
  },
  {
    name: "financieel",
    path: "/financieel-overzicht",
    meta: { ...(indexGS8_14mW5u1WyR1DBn18Z9IiMKM_45nprPG7snX_0J2psMeta || {}), ...{"middleware":["auth","avinvestor","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/financieel-overzicht/index.vue")
  },
  {
    name: "einde-looptijd-lening-hash",
    path: "/einde-looptijd-lening/:hash()",
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/einde-looptijd-lening/[hash].vue")
  },
  {
    name: "sso-exchangeToken-fundKey",
    path: "/sso/:exchangeToken()/:fundKey()",
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/sso/[exchangeToken]/[fundKey].vue")
  },
  {
    name: "mijn-profiel-naw-gegevens",
    path: "/mijn-profiel/naw-gegevens",
    meta: { ...(indexwaYVXzAotGiXNJfdWKqPuVTVlIXhUTJeWDCWypAlKfUMeta || {}), ...{"middleware":["auth","investor"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-profiel/naw-gegevens/index.vue")
  },
  {
    name: "onboarding-signing_id-token",
    path: "/onboarding/:signing_id()/:token()",
    meta: _91token_93vwt6RoLAF7H8_Bmm8273nwkuuuQ2hWlIQbfZJ_45_4549GQMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/onboarding/[signing_id]/[token].vue")
  },
  {
    name: "onboarding-bedankt-experience",
    path: "/onboarding/bedankt/:experience()",
    meta: { ...(_91experience_93DO6xvH24qwnkFlTO8jn2h1WDwSW_PHjMoG1WtWD7bxMMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/onboarding/bedankt/[experience].vue")
  },
  {
    name: "financieel-overzicht-rente",
    path: "/financieel-overzicht/rente",
    meta: { ...(indexTJAcQv_45yIl78aioadt_45ZF7jd6cVS_8uf9_45IpbAehy4IMeta || {}), ...{"middleware":["auth","avinvestor","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/financieel-overzicht/rente/index.vue")
  },
  {
    name: "mijn-profiel-iban-overzicht",
    path: "/mijn-profiel/iban-overzicht",
    meta: { ...(indexh9sB5Fltbpq09UJwevLnQ_45BM56HWoM0EbpwN3jxqAVAMeta || {}), ...{"middleware":["auth","investor"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-profiel/iban-overzicht/index.vue")
  },
  {
    name: "mijn-aanvragen-offerNumber",
    path: "/mijn-aanvragen/:offerNumber()",
    meta: indexfkxyox4y1i04LZ_gXSqY9V7ibgQuomNJ_czESwhGLhEMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-aanvragen/[offerNumber]/index.vue")
  },
  {
    name: "mogelijk-fonds-id-deelname",
    path: "/mogelijk-fonds/:id()/deelname",
    meta: { ...(index_D3iRcr4UfNnMPOBHQzqG3g9YxlokKNFYcpXO184rw8Meta || {}), ...{"middleware":["auth","fund","currentfund"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mogelijk-fonds/[id]/deelname/index.vue")
  },
  {
    name: "mogelijk-fonds-id-overmaken",
    path: "/mogelijk-fonds/:id()/overmaken",
    meta: { ...(indexpBSV39xzvNqT07Iz9zj2vgVcE213ZAtjGFlth0U_BxkMeta || {}), ...{"middleware":["auth","fund","currentfund"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mogelijk-fonds/[id]/overmaken/index.vue")
  },
  {
    name: "/financieel-overzicht/financien.page-title",
    path: "/financieel-overzicht/financien",
    meta: { ...(indexJdnwt_45A1WJBljvrDiAVbIA6GY5tVBiLaCdcEC_45oYf3YMeta || {}), ...{"middleware":["auth","avinvestor","mobile"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/financieel-overzicht/financien/index.vue")
  },
  {
    name: "mogelijk-fonds-id-documenten",
    path: "/mogelijk-fonds/:id()/documenten",
    meta: { ...(indexFdxJgsxX_45SR0k2Saty77RTgNKIUsfiNVgjY2_45VwGCbMMeta || {}), ...{"middleware":["auth","fund","currentfund"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mogelijk-fonds/[id]/documenten/index.vue")
  },
  {
    name: "sso-exchangeToken-onboarding",
    path: "/sso/:exchangeToken()/onboarding",
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/sso/[exchangeToken]/onboarding/index.vue")
  },
  {
    name: "mogelijk-fonds-id-inschrijving",
    path: "/mogelijk-fonds/:id()/inschrijving",
    meta: { ...(indexNo4IaYmb2HGsCApV5uBw99RbUSbcgKyjbbvvDBurUOUMeta || {}), ...{"middleware":["auth","fund","currentfund"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mogelijk-fonds/[id]/inschrijving/index.vue")
  },
  {
    name: "mogelijk-fonds-id-ondertekenen",
    path: "/mogelijk-fonds/:id()/ondertekenen",
    meta: { ...(indexmF5Vt8aF2e95FVqXd5UUydxvy957nP7Hmm90fr8ALb4Meta || {}), ...{"middleware":["auth","fund","currentfund"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mogelijk-fonds/[id]/ondertekenen/index.vue")
  },
  {
    name: "partnerplan-deel-gegevens",
    path: "/mijn-partnerplan/:token()/:choice()",
    meta: indexpetWy7dU6uBpK0ohzcRTW_PRKqTsMSueNGPQsOj_mLYMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-partnerplan/[token]/[choice]/index.vue")
  },
  {
    name: "sso-exchangeToken-onboarding-aanvraag",
    path: "/sso/:exchangeToken()/onboarding/aanvraag",
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/sso/[exchangeToken]/onboarding/aanvraag.vue")
  },
  {
    name: "aanbod-optie-propertyId-hash-choice",
    path: "/aanbod-optie/:propertyId()/:hash()/:choice()",
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/aanbod-optie/[propertyId]/[hash]/[choice].vue")
  },
  {
    name: "mijn-organisaties-bedrijfs-gegevens",
    path: "/mijn-organisaties/bedrijfs-gegevens",
    meta: { ...(indexbknDebENroFtu9lT85JYhhB2Tof7En9uyvDNcUIbrpkMeta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-organisaties/bedrijfs-gegevens/index.vue")
  },
  {
    name: "mijn-profiel-digitaal-identificeren",
    path: "/mijn-profiel/digitaal-identificeren",
    meta: { ...(indexkz_45w5OoYcs4OXzSv0EXIWu5PLF7AvtQsMRZcnPQn3sQMeta || {}), ...{"middleware":["onfido"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-profiel/digitaal-identificeren/index.vue")
  },
  {
    name: "mijn-aanvragen-offerNumber-herkomst",
    path: "/mijn-aanvragen/:offerNumber()/herkomst",
    meta: indexVx1xqskUBdFP8_45fcgVk7NbtRt_jnm8B54cPgzuu7_GAMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-aanvragen/[offerNumber]/herkomst/index.vue")
  },
  {
    name: "fonds-optie-property_id-hash-type",
    path: "/fonds-optie/:property_id()/:hash()/:type()",
    meta: indexcvOxTakMYWc4H187s48DCitvJReKKo9I1hqqPRLyP2EMeta || {},
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/fonds-optie/[property_id]/[hash]/[type]/index.vue")
  },
  {
    name: "mijn-organisaties-companyId-iban-overzicht",
    path: "/mijn-organisaties/:companyId()/iban-overzicht",
    meta: { ...(indexVsz4hCjlgg1ufumGtnT3KykC2kkeqR3pOyrPAVDfPngMeta || {}), ...{"middleware":["company"]} },
    component: () => import("/shared/home/frontend/deployr/releases/20250716141545/packages/investors/pages/mijn-organisaties/[companyId]/iban-overzicht/index.vue")
  }
]